module.exports = __webpack_public_path__ + "img/add-icon.77a7201e.svg";